import React from 'react';
import { DropdownControl } from '@ver-uds/uswds-react';
import { useFormContext } from 'react-hook-form';
import { MarketingChannel } from 'eve-account-client';

type FormValues = {
  MarketingQuestionPrimary: string;
};

interface MarketingQuestionPrimaryProps {
  data: MarketingChannel[] | undefined;
  onOptionSelected: (selected: string) => void;
  questionLabel: string;
}

const MarketingQuestionPrimary = ({
  data,
  onOptionSelected,
  questionLabel,
}: MarketingQuestionPrimaryProps): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { register } = useFormContext<FormValues>();

  return (
    <DropdownControl
      id="marketing-question-primary"
      name="marketingQuestionPrimary"
      className="tablet:grid-col-5 desktop:grid-col-5"
      label={questionLabel}
      ref={register()}
      onChange={({ target }) => onOptionSelected(target.value)}
    >
      <option value="">- Select -</option>
      {data?.map(({ code, displayName }) => (
        <option key={code} value={code}>
          {displayName}
        </option>
      ))}
    </DropdownControl>
  );
};

export default MarketingQuestionPrimary;
